import { createSlice } from '@reduxjs/toolkit';

import { api } from '../../api';

export const usersSlice = createSlice({
  name: 'users',
  initialState: {
    users :[],
    unApprovedusers: [],
    success : false
  },
  reducers: {
    usersFetchStart(state) {
      state.loading = true;
      state.users = [];
      state.error = null;
      state.unApprovedusers = []
      state.success = false;
    },
    usersFetchSuccess(state, action) {
      state.loading = false;
      state.users = action.payload;
    },
    usersFetchFailed(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },
    unApprovedusersFetchSuccess(state, action) {
      state.loading = false;
      state.unApprovedusers = action.payload.users;
    },
    approveUserSuccess(state, action) {
      state.loading = false;
      state.success = true;
    },
    denyUserSuccess(state, action) {
      state.loading = false;
      state.deny = true;
    },
    denyUserFailure(state, action) {
      state.loading = false;
      state.deny = false;
    }
  },
});

export const {
  usersFetchStart, usersFetchSuccess, usersFetchFailed,unApprovedusersFetchSuccess,
  approveUserSuccess, denyUserSuccess
} = usersSlice.actions;

export default usersSlice.reducer;

export const selectLoading = state => state.users.loading;
export const selectUsers = state => state.users.users;
export const selectUnApprovedusers = state => state.users.unApprovedusers;
export const selectSuccess = state => state.users.success;
export const selectDeny = state => state.users.deny;

export const fetchUsers = () => async dispatch => {
  dispatch(usersFetchStart());
  try {
    const data = await api('/api/get_portal_users');
    const {
      preview : users
    } = data;
    dispatch(usersFetchSuccess({
      users
    }));
  } catch (err) {
    dispatch(usersFetchFailed({
      message: err.message,
      status: err.status,
    }));
  }
};
//get_unapproved_users

export const fetchUnapprovedUsers = () => async dispatch => {
  dispatch(usersFetchStart());
  try {
    const data = await api('/api/get_unapproved_users');
    const {
      preview : users
    } = data;
    dispatch(unApprovedusersFetchSuccess({
      users
    }));
  } catch (err) {
    dispatch(usersFetchFailed({
      message: err.message,
      status: err.status,
    }));
  }
};

export const approveUser = (email) => async dispatch => {
  dispatch(usersFetchStart());
  try {
     await api('/api/approve_user',{
      email,
    }, true);
    
    dispatch(approveUserSuccess('success'));
  } catch (err) {
    dispatch(usersFetchFailed({
      message: err.message,
      status: err.status,
    }));
  }
};

export const denyUser = (email) => async dispatch => {
  dispatch(usersFetchStart());
  try {
     await api('/api/deny_user',{
      email,
    }, true);
    
    dispatch(denyUserSuccess('User approval declined.'));
  } catch (err) {
    dispatch(usersFetchFailed({
      message: err.message,
      status: err.status,
    }));
  }
};




